// Helper functions

function toggleClass(element: HTMLElement, classes: string[]) {
  classes.forEach((cls) => element.classList.toggle(cls));
}

export function toggleDataAttribute(element: HTMLElement, attr: string) {
  const isOpen = element.getAttribute(attr) == 'true';
  element.setAttribute(attr, (!isOpen).toString());
  return !isOpen;
}

// Main mobile Menu with tab and click support
const menuTrigger = document.getElementById('menu-trigger') as HTMLElement;
const menuElement = document.getElementById('menu') as HTMLElement;
let currentVisibleItem: HTMLElement | null = null;

if (menuTrigger && menuElement) {
  menuTrigger.addEventListener('click', toggleMenu);

  function toggleMenu() {
    toggleDataAttribute(menuElement, 'data-open');
    toggleClass(document.body, ['overflow-hidden']);
    toggleDataAttribute(menuTrigger, 'aria-expanded');

    // Toggle icon visibility
    const iconOpen = document.getElementById('icon-open');
    const iconClose = document.getElementById('icon-close');
    if (iconOpen && iconClose) {
      iconOpen.classList.toggle('hidden');
      iconClose.classList.toggle('hidden');
    }
  }

  // Handle keyboard navigation for the menu trigger
  menuTrigger.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (menuElement) {
        toggleDataAttribute(menuElement, 'data-open');
      }
    }
  });
}

const submenus = document.querySelectorAll<HTMLElement>('.submenu-trigger');

submenus.forEach((submenuTrigger) => {
  submenuTrigger.addEventListener('click', () =>
    toggleDataAttribute(submenuTrigger, 'data-open')
  );
  submenuTrigger.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      if (currentVisibleItem && currentVisibleItem !== submenuTrigger) {
        // Close the previously opened
        currentVisibleItem.setAttribute('data-open', 'false');
      }
      submenuTrigger.setAttribute('data-open', 'true');
      currentVisibleItem = submenuTrigger;
    }
  });
});

const tabTriggers = document.querySelectorAll<HTMLElement>('.tab-triggers');

tabTriggers.forEach((tabTrigger) => {
  tabTrigger.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') {
      const item = this.querySelector('.tab-content') as HTMLElement | null;
      if (item) {
        item.setAttribute('data-open', 'true');
        currentVisibleItem = item;
        item.addEventListener('focusout', function (event) {
          // Close the tab content if the focus is outside the tab content
          if (!item.contains(event.relatedTarget as Node)) {
            item.setAttribute('data-open', 'false');
          }
        });
      }
    }
    // Close using escape key
    if (event.key === 'Escape') {
      currentVisibleItem?.setAttribute('data-open', 'false');
    }
  });
});

// Search popup toggle
const searchPopup = document.getElementById('mobile-search-popup');

function toggleSearchPopup() {
  if (!searchPopup) return;
  toggleDataAttribute(searchPopup, 'data-open');
}

const searchTrigger = document.getElementById('mobile-search-trigger');
const closeSearch = document.getElementById('close-search');

searchTrigger?.addEventListener('click', toggleSearchPopup);
closeSearch?.addEventListener('click', toggleSearchPopup);

// Language popup toggle
const languagePopup = document.getElementById('language-popup');
function toggleLanguagePopup() {
  if (!languagePopup) return;
  toggleDataAttribute(languagePopup, 'data-open');
}

const languageToggle = document.getElementById('language-toggle');
languageToggle?.addEventListener('click', toggleLanguagePopup);

// Tab buttons for content sections (faqs)
const tabButtons = document.querySelectorAll<HTMLElement>('.tab-button');

if (tabButtons.length > 0) {
  function setActiveTab(index: number) {
    document
      .querySelectorAll<HTMLElement>('[data-tab-content]')
      .forEach((section) => {
        const sectionIndex = Number(section.getAttribute('data-tab-content'));
        const isActive = sectionIndex === index;
        section.setAttribute('data-open', isActive.toString());
      });

    tabButtons.forEach((button) => {
      const buttonIndex = Number(button.getAttribute('data-tab'));
      const isActive = buttonIndex === index;
      button.setAttribute('data-open', isActive.toString());
    });
  }

  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const index = button.getAttribute('data-tab');
      if (index !== null) setActiveTab(Number(index));
    });
  });

  setActiveTab(0);
}
